import { Decoration } from "@app/shared/models/decoration";
import { Media } from "@app/shared/models/media";
export class PublicOfferAsset {
  uuid:string;
  type:string;
  id:number;
  savePercent?:string;
  rewards?:string;
  decoration?:Decoration;
  media?:Media;
  originOwner?:string;
  isHero?:boolean;
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/pmclient-uat/src/app/shared/models/publicOfferAsset.ts